import type { BC } from '@tribeplatform/react-slate-kit/types'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { NetworkMemberList } from './NetworkMemberList'
import { SpaceMemberList } from './SpaceMemberList'
import { MembersBlockProps } from './types'

export const MembersBlock: BC<MembersBlockProps> = props => {
  const { title, description, showTitle, spaceId, ...rest } = props

  return (
    <Card>
      {(title || description) && (
        <Card.Header
          title={showTitle ? title : ''}
          description={description}
          size="sm"
        />
      )}
      <Card.Content>
        {spaceId ? (
          <SpaceMemberList spaceId={spaceId} {...rest} />
        ) : (
          <NetworkMemberList {...rest} />
        )}
      </Card.Content>
    </Card>
  )
}
